<div class="row ">
    <div class="col-6  btn-group dateFilter fn-event-filter-container datefilterBtn" role="group">
        <fn-button [iconAddonAfter]="uiEventFilterMap.fnBtnIconClass" id="btnGroupDrop2" class="dateFilterBtn" (click)="showOrHideDropDown(!uiEventFilterMap.isOpenDropDown,uiEventFilterMap.isOpenDropDown)" [btnClass]="uiEventFilterMap.fnBtnClass" [text]="uiMap.selectedKey"></fn-button>
        <ul class="dropdown-menu left fn-event-filter" [ngClass]="{'show': uiEventFilterMap.isOpenDropDown}" aria-labelledby="btnGroupDrop2">
            <li style="width:347px">
                <div class="event-filter-data">
                    <ul class="row event-filter-list">
                        <li class="col-6 event-filter-item" *ngFor="let eventFilter of filterOptionArray">
                            <fn-radio [label]="eventFilter.desc" [labelClass]="'filter-radio-label'" [id]="eventFilter.id" [name]="eventFilter.id" [(ngModel)]="uiMap.selectedOption" (clickCallback)="enableAccept($event,eventFilter)"></fn-radio>
                        </li>
                    </ul>
                </div>
            </li>
            <li class="event-filter-footer">
                <div class="row">
                    <div class="col">
                        <fn-button (click)="resetFilter()" type="danger" btnClass="btn-round btn-xs" [ngClass]="{'disable': uiEventFilterMap.isClearDisabled}" text="Clear"></fn-button>
                    </div>
                    <div class="col date-filter-right">
                        <fn-button (click)="applyFilter()" btnClass="btn-xs btn-round btn-info" [ngClass]="{'disable': uiEventFilterMap.isApplyDisabled}" text="Apply"></fn-button>
                    </div>
                </div>
            </li>
        </ul>
    </div>
    <div class="col-6  btn-group dateFilter fn-event-filter-container datefilterBtn">
        @if (uiMap.selectedOption != 'RANGE') {
        <div>
            <fn-date-picker [ngClass]="{'disable': uiMap.selectedOption != 'CUSTOM' }" [globalConfig]="dateConfig" [selectedDate]="selectedDate" [currentDate]="currentDate" (nextPrevCallback)="nextPrevDate($event)" (callback)="datePickerCallback($event)">
            </fn-date-picker>
        </div>
        }@else if (uiMap.selectedOption == 'RANGE' || isRangeLoadingDone) {
        <div>
            <fn-date-range-picker [startDate]="dateRangeConfig.startDate" [futureDateDisabled]="true" [maxDate]="dateRangeConfig.maxDate" [enableDateRange]="true" [endDate]="dateRangeConfig.endDate" [maxDayNum]="dateRangeConfig.maxDayNum" [dateFormat]="dateRangeConfig.dateShowingFormat" [validationMsg]="dateRangeConfig.dateValidationMsg" [enableDateRange]="'true'"
                                  (dateCB)="dateRangePickerCallback($event)">
            </fn-date-range-picker>
        </div>
        }
    </div>
</div>
